import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Users } from '@C/Director/Users/RouteComponents';

const RouteSetup = () => {
  return (
    <Switch>
      <Route path="/users/users-list" component={Users} />
      <Route path="/users/users-list/*">
        <Redirect to={`/users/users-list`} />
      </Route>
    </Switch>
  );
};

export { RouteSetup };
